import { useEffect, useState } from "react";
import { Form, Modal, Button, Container } from "react-bootstrap";
import useApi from "../../../apiProvider";

import "../../generic/css/ResponsiveForms.css";
import "../css/SiteCircuitManagement.css";
import "../css/InfoModal.css";
import { useSiteContext } from "../Providers/SSCProvider";
import { useRoleContext } from "../Providers/RoleProvider";

const NotesModal = ({ notesData, setNotesModal, setUpdatedCircuit }) => {
  const { rebuildHierarchy, setIsLoading, isLoading, handleCircuitChange } =
    useSiteContext();
  const { isAdmin } = useRoleContext();

  const [circuitNote, setCircuitNote] = useState("");
  const [editMode, setEditMode] = useState(false);
  const closeModal = () => setNotesModal({ show: false });

  useEffect(() => {
    const parsedNote = notesData.circuitNote
      ? notesData.circuitNote.replace(/\\n/g, "\n")
      : "";
    setCircuitNote(parsedNote);
    setEditMode(false);
  }, [notesData.circuitNote]);

  const handleSave = async () => {
    if (!notesData.circuitId) return;

    setIsLoading(true);

    try {
      const isNewCircuit = /^\d{13,}$/.test(notesData.circuitId);

      if (!isNewCircuit) {
        const results = await useApi.updateCircuitNote(
          notesData.circuitId,
          circuitNote,
        );
        console.log("results: ", results.returnData);
        rebuildHierarchy({ circuits: results.returnData });
      } else {
        setUpdatedCircuit((prev) => ({ ...prev, circuitNote: circuitNote }));
        handleCircuitChange(notesData.structureId, notesData.circuitId, {
          circuitNote,
        });
        setNotesModal((prev) => ({ ...prev, circuitNote }));
      }
      closeModal();
    } catch (error) {
      console.error("Failed to save circuitNote:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNoteChange = (e) => {
    setCircuitNote(e.target.value);
    setEditMode(true);
  };

  return (
    <Container>
      <Modal
        show={notesData.show}
        onHide={closeModal}
        centered
        dialogClassName="custom-modal"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
      >
        <div className="mt-4 ps-4">
          <h4>Circuit Notes</h4>
        </div>
        <Modal.Body style={{ overflowY: "auto" }}>
          <Form.Control
            as="textarea"
            value={circuitNote}
            onChange={handleNoteChange}
            placeholder="No notes available for this circuit. You can add notes here."
            disabled={!isAdmin}
            style={{
              minHeight: "300px",
              backgroundColor: !isAdmin ? "#f5f5f5" : "white",
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              width: "80px",
              color: "#707782",
              backgroundColor: "#E5E7EB",
              border: "none",
            }}
            onClick={closeModal}
          >
            Cancel
          </Button>
          <Button
            className="cursorButton"
            onClick={handleSave}
            disabled={!isAdmin || !editMode || isLoading}
            style={{
              width: "80px",
              color: "#FFFFFF",
              backgroundColor: "#198754",
              border: "none",
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default NotesModal;
